// Fuzzball Quiz Calculator
// Quantity-based calculator — cansPerDay drives pack/bag recommendations.

window.QuizCalculator = {
  // Main calculation method — returns recommendations based on food type and cansPerDay
  calculate(data) {
    const catName = data.fuzzballer_name;

    // Get age in months - either from birthdate or age range
    let months;
    if (data.age_in_months !== undefined) {
      months = data.age_in_months;
    } else {
      months = this.convertAgeRangeToMonths(data.age_range);
    }

    const isKitten = (months < 12);

    const diet = data.wet_dry_preference;
    const cansPerDay = parseInt(data.cans_per_day) || 1;

    let bagsNeeded = 0;
    let packsNeeded = 0;

    if (diet === 'Wet') {
      packsNeeded = cansPerDay * 4;
      bagsNeeded = 0;
    } else if (diet === 'Dry') {
      packsNeeded = 0;
      bagsNeeded = 4;
    } else {
      // 'Both'
      packsNeeded = cansPerDay * 4;
      bagsNeeded = 4 - cansPerDay;
    }

    return {
      catName,
      bagsNeeded,
      cansNeeded: 0,
      packsNeeded,
      diet,
      isKitten,
      months,
      ageBracket: this.getAgeBracketName(months),
      lifestyle: data.lifestyle,
      dislikes: data.disliked_flavors || [],
      breed: data.breed,
      ageRange: data.age_range,
      cansPerDay
    };
  },

  // Convert age range to months
  convertAgeRangeToMonths(ageRange) {
    // Handle new specific age values
    switch (ageRange) {
      case 'Kitten':
      case 'Kitten (under 1 year)': // Legacy support
        return 6; // Use midpoint for kitten calculations
      case '1 year old':
        return 12;
      case '2 years old':
        return 24;
      case '3 years old':
        return 36;
      case '4 years old':
        return 48;
      case '5 years old':
        return 60;
      case '6 years old':
        return 72;
      case '7 years old':
        return 84;
      case '8 years old':
        return 96;
      case '9 years old':
        return 108;
      case '10 years old':
        return 120;
      case 'Senior':
      case 'Senior (over 8 years)': // Legacy support
      case 'Senior (over 10 years)': // Legacy support
        return 132; // Use 11 years for senior calculations
      case 'Adult':
      case 'Adult (1-10 years)': // Legacy support
      case 'Adult (1-8 years)': // Legacy support
        return 60; // Midpoint of 1-10 years ≈ 5 years
      default:
        return 48; // Default to adult (4 years) when age unset (e.g. Wet-path skip)
    }
  },

  // Get age bracket name
  getAgeBracketName(months) {
    if (months < 5) return '2-4';
    if (months < 9) return '5-8';
    if (months < 12) return '9-12';
    return '12+';
  },

  // Calculate bundle price estimate.
  // Defaults are Liquid-injected lower-bound variant prices from
  // sections/quiz.liquid → window.QuizConfig.defaultPrices. The live total
  // (post-selection) is computed in quiz-bundle-builder-v2 from actual
  // Shopify variant prices — this estimate is only a "from" floor before
  // the bundle initialises.
  calculateBundlePrice(recommendations) {
    const defaults = (window.QuizConfig && window.QuizConfig.defaultPrices) || {};
    const wetFoodPrice = typeof defaults.wetPerPack === 'number' ? defaults.wetPerPack : 7.50;
    const dryFoodPrice = typeof defaults.dryPerBag === 'number' ? defaults.dryPerBag : 5.50;

    const wetTotal = recommendations.packsNeeded * wetFoodPrice;
    const dryTotal = recommendations.bagsNeeded * dryFoodPrice;

    return wetTotal + dryTotal;
  },

  // Calculate bundle price for multiple cats
  calculateMultiCatBundlePrice(recommendations) {
    if (!recommendations.cats) {
      return this.calculateBundlePrice(recommendations);
    }

    let totalPrice = 0;
    Object.values(recommendations.cats).forEach(catRec => {
      totalPrice += this.calculateBundlePrice(catRec);
    });

    return totalPrice;
  }
};
